import { ArrowUpRight } from 'lucide-react';

const team = [
  {
    name: 'Seth Gideon John',
    linkedin: 'https://www.linkedin.com/in/seth-gideon-john/',
  },
  {
    name: 'Elijah Luk',
    linkedin: 'https://www.linkedin.com/in/elijah-luk-b38b27389/',
  },
  {
    name: 'Arancha Felgueroso Gonzalez',
    linkedin: 'https://www.linkedin.com/in/arancha-felgueroso-gonzalez-734080383/',
  },
  {
    name: 'Shailan Mathanram',
    linkedin: 'https://www.linkedin.com/in/shailan-mathanram-672399393/',
  },
  {
    name: 'Jayden Lee',
    linkedin: 'https://www.linkedin.com/in/jayden-lee-821097383/',
  },
];

export function ConnectPage() {
  return (
    <section
      id="connect"
      className="min-h-screen scroll-mt-24 bg-neutral-950 pb-24 pt-32 text-neutral-100 md:pt-36"
    >
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <p className="text-xs uppercase tracking-[0.22em] text-white">Connect</p>
        <h1 className="mt-3 text-2xl font-semibold tracking-tight md:text-3xl">
          The team behind Valinor Dynamics
        </h1>
        <p className="mt-3 max-w-3xl text-sm text-white md:text-base">
          Valinor Dynamics is built by a team. Reach out to any of us on LinkedIn.
        </p>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {team.map((member) => (
            <a
              key={member.name}
              href={member.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-between rounded-xl border border-white/15 bg-black px-5 py-5 transition hover:border-white/40 hover:shadow-[0_0_30px_rgba(255,255,255,0.08)]"
            >
              <div>
                <p className="text-xs uppercase tracking-[0.22em] text-neutral-500">
                  Team
                </p>
                <p className="mt-1 text-lg font-semibold tracking-tight text-white">
                  {member.name}
                </p>
                <p className="mt-1 text-sm text-white">LinkedIn</p>
              </div>
              <ArrowUpRight className="h-5 w-5 text-white transition group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
